import type { DialogProps } from '@_/ui';
import type { VenueListFilterSchema } from './schema.ts';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { FilterDialogContent } from '@_/components';
import { withDialog, StackedLayout, StackedLayoutSection } from '@_/ui';
import { DistrictFilter } from '#src/components/filters/DistrictFilter.tsx';
import { labelI18n } from '#src/i18nMessages/index.ts';

export const VenueListFilterDialog = withDialog(
  {},
  function VenueListFilterDialogContent({
    onOpenChange,
    onSuccess,
    value
  }: Pick<DialogProps, 'onOpenChange'> & {
    onSuccess?: (value: VenueListFilterSchema) => void;
    value: VenueListFilterSchema;
  }) {
    const [internalValue, setInternalValue] = useState(value);

    const submit = () => {
      onOpenChange(false);
      onSuccess?.(internalValue);
    };

    const reset = useCallback(() => {
      setInternalValue({
        countryZoneCodes: []
      });
    }, []);

    return (
      <FilterDialogContent onReset={reset} onSubmit={submit}>
        <StackedLayout size="sm">
          <StackedLayoutSection heading={<FormattedMessage {...labelI18n.districts} />} initialOpen>
            <DistrictFilter
              onChange={useCallback(countryZoneCodes => {
                setInternalValue(prev => ({ ...prev, countryZoneCodes }));
              }, [])}
              value={internalValue.countryZoneCodes}
            />
          </StackedLayoutSection>
        </StackedLayout>
      </FilterDialogContent>
    );
  }
);
